export default "__VITE_ASSET__95mJ1gVb__"